// @flow
import * as React from 'react';
import anime from 'animejs';
import { withProps } from 'recompose';

import { colors } from '@peachjar/components';

const { platinum } = colors;

type RecomposeProps = {|
  +styles: { [key: string]: string },
|};

type OwnProps = {|
  +id: string,
  +children: React.Node,
|};

type Props = {|
  ...RecomposeProps,
  ...OwnProps,
|};

/*
  TODO (quinkinser) This is a first pass, make the component more reusable
    - should accept styles
    - animation should be in a HOC instead of in this component
*/
class InlineTip extends React.Component<Props> {
  componentDidMount() {
    const { id } = this.props;
    anime({
      targets: `#${id}`,
      easing: 'linear',
      opacity: [0, 1],
      translateY: '2em',
      duration: 300,
    });
  }

  render() {
    const { styles, children, id } = this.props;
    return (
      <div id={id} style={styles.validator}>
        {children}
      </div>
    );
  }
}

const styles = {
  validator: {
    marginLeft: '-5px',
    marginBottom: '10px',
    backgroundColor: platinum,
    display: 'flex',
    alignItems: 'center',
  },
};

export default withProps(props => ({
  styles,
  id: `pjp-inline-tip-${props.id}`,
}))(InlineTip);



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/UserRegistration/components/InlineTip.jsx